import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dropdown-menu absolute top-full ml-4 min-w-52 h-auto overflow-hidden rounded-b-2xl px-1 py-3 flex flex-col gap-2"
}
const _hoisted_2 = { class: "dropdown-text text-base" }

import { computed, ref } from 'vue';
interface Props {
    title: string;
    options: Record<string,  string>;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'NavDropdown',
  props: {
    title: {},
    options: {}
  },
  setup(__props: any) {

const props = __props;

const opened = ref(false);
const dropdownOptions = computed(() => Object.entries(props.options));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "relative dropdown-wrapper h-full",
    onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (opened.value = true)),
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (opened.value = false))
  }, [
    _createElementVNode("span", {
      class: "links-dropdown link text-base",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (opened.value = !opened.value), ["stop"]))
    }, _toDisplayString(props.title) + " ▼", 1),
    _createVNode(_Transition, { name: "nav-dropdown" }, {
      default: _withCtx(() => [
        (opened.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dropdownOptions.value, ([pageTitle, pageLink], index) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: pageLink,
                  to: pageLink,
                  class: "dropdown-item px-3 py-2 cursor-pointer",
                  style: _normalizeStyle({ '--drop-index': index }),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (opened.value = false))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(pageTitle), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "style"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 32))
}
}

})